import React from "react"
import NewsArticle from "./NewsArticle"
import { Link, graphql, useStaticQuery } from "gatsby"
import { analyticsAction } from "/src/utils/analytics"

function News() {
  const data = useStaticQuery(graphql`
    query GhostBlogQuery {
      allGhostPost(limit: 3, skip: 0) {
        edges {
          node {
            ...GhostPostFields
            featureImage {
              childImageSharp {
                gatsbyImageData(
                  width: 352
                  height: 198
                  quality: 50
                  formats: [AUTO, WEBP]
                )
              }
            }
            profileImage {
              childImageSharp {
                gatsbyImageData(
                  width: 40
                  height: 40
                  quality: 90
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }
    }
  `)

  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20 border-t border-gray-800">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
            <h2 className="h2 mb-4" data-aos="fade-up">
              Latest blog posts
            </h2>
            <p
              className="text-xl text-gray-400"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Exploring the diverse world of film together.
            </p>
          </div>

          {/* Articles list */}
          <div className="max-w-sm mx-auto md:max-w-none">
            <div className="grid gap-12 md:grid-cols-3 md:col-gap-6 md:row-gap-8 items-start">
              {data &&
                data.allGhostPost.edges.map(posts => (
                  <NewsArticle {...posts} key={posts.node.slug} />
                ))}
            </div>
          </div>

          <div className="flex pt-10 justify-center" data-aos="fade-up">
            <Link
              className="btn text-gray-100 bg-gray-700 hover:bg-gray-800 capitalize"
              to="/blog/"
              onClick={() => analyticsAction("landing_blog_click")}
            >
              More articles{" "}
              <span className="ml-1" role="img" aria-label="">
                🗞
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default News
